import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Snackbar from '@pedidosya/web-fenix/system/Snackbar';
import { MESSAGE_TYPE } from './constants';

function Toast({ type, onClose, title, onCallToAction, actionLabel }) {
  const [show, setShow] = useState(true);

  const onCloseToast = () => {
    if (onClose) onClose();
    setShow(false);
  };

  return (
    <Snackbar
      actionLabel={actionLabel}
      label={title}
      onClickAction={onCallToAction}
      onClose={onCloseToast}
      show={show}
      type={type}
    />
  );
}

Toast.defaultProps = {
  type: MESSAGE_TYPE.INFO,
};

Toast.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(MESSAGE_TYPE)),
  onCallToAction: PropTypes.func,
  actionLabel: PropTypes.string,
};

export default Toast;
